// infraqap/components/Dashboards/InspecteeDashboard.tsx
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { FaPlus, FaFile, FaImage, FaWrench, FaFileAlt, FaUpload } from 'react-icons/fa'; //FaMapMarkerAlt
import { useRouter } from 'next/navigation'
import { getInspections } from '@/utils/all_apis/admin'; //deleteInspectionType,, getInspectionTypes, getSites
// import { formatNumber } from '@/utils/func';

// interface Inspection {
//   id: number;
//   title: string;
//   status: string;
//   inspector: string;
//   date: string;
//   site: string;
//   description?: string;
// }


interface InspectionType {
  id: any;
  type: string;
}

interface Inspection {
  id: number;
  status: string;
  date: string;
  inspectionSite: any;
  description: string;
  inspector: any;
  unique_id: any;
  user_id: any;
  inspectionType: InspectionType
}

const statusColors: { [key: string]: string } = {
  "Closed": 'bg-gray-400',
  'Pending': 'bg-yellow-400',
  "Approved": 'bg-green-400',
  "Rejected": 'bg-red-400',
  'Awaiting Approval': 'bg-orange-400',
  'On Hold': 'bg-blue-400',
  'Started': 'bg-green-400'
};

const defaultColor = 'bg-gray-500'; // Default color for unknown statuses

const getStatusColor = (status: string): string => {
  return statusColors[status] || defaultColor;
};

// const dummyData: Inspection[] = [
//   {
//     id: 1,
//     title: 'Inspection 1',
//     status: 'Submitted',
//     inspector: 'Inspector A',
//     date: '2023-10-01',
//     site: 'Site 1',
//     description: 'Initial inspection',
//   },
//   {
//     id: 2,
//     title: 'Inspection 2',
//     status: 'Awaiting Approval',
//     inspector: 'Inspector B',
//     date: '2023-10-02',
//     site: 'Site 2',
//   },
// ];

// const statusColors: { [key: string]: string } = {
//   Submitted: 'bg-gray-500',
//   'Awaiting Approval': 'bg-yellow-500',
//   Approved: 'bg-green-500',
//   Rejected: 'bg-red-500',
//   'Awaiting Further Action': 'bg-orange-500',
//   'On Hold': 'bg-blue-500',
// };

const InspecteeDashboard: React.FC = () => {
  // const [showNewInspectionForm, setShowNewInspectionForm] = useState(false);
    const [inspections, setInspections] = useState<Inspection[]>([]);
  const router = useRouter()

  useEffect(() => {
      const fetchData = async () => {
  
        const fetchedInspections = await getInspections();
        setInspections(fetchedInspections);
  
        // const fetchedSites = await getSites();
        // setSites(fetchedSites);
  
        // const fetchedInspectionTypes = await getInspectionTypes();
        // setInspectionTypes(fetchedInspectionTypes);
      };
  
      fetchData();
    }, []);

  // const handleNewInspectionSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   alert('New inspection created!');
  //   setShowNewInspectionForm(false);
  // };

  return (
    <div className="flex flex-col md:flex-row">
      {/* Left Half: Inspections */}
      <div className="w-full md:w-1/2 p-4">
        {/* <h1 className="text-2xl font-bold mb-4">Inspections</h1>
        <button
          // onClick={() => setShowNewInspectionForm(true)}
          onClick={()=>router.push('/add-new-inspection')}
          className="bg-blue-500 text-white px-4 py-2 rounded mb-4 flex items-center"
        >
          <FaPlus className="mr-2" /> Add New Inspection
        </button> */}
        {/* {showNewInspectionForm && (
          <form onSubmit={handleNewInspectionSubmit} className="bg-white p-4 rounded shadow mb-4">
            <h2 className="text-xl font-bold mb-2">New Inspection</h2>
            <div className="mb-4">
              <label className="block text-gray-700">Title</label>
              <input type="text" className="w-full border rounded px-3 py-2" required />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Inspector</label>
              <input type="text" className="w-full border rounded px-3 py-2" required />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Date</label>
              <input type="date" className="w-full border rounded px-3 py-2" required />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Site</label>
              <input type="text" className="w-full border rounded px-3 py-2" required />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Description</label>
              <textarea className="w-full border rounded px-3 py-2"></textarea>
            </div>
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
              Submit
            </button>
          </form>
        )} */}
        {/* <ul className="space-y-4">
          {dummyData.map((inspection) => (
            <li key={inspection.id} className="bg-white p-4 rounded shadow">
              <Link href={`/inspection-detail?id=${inspection.id}`} className="text-blue-500 hover:underline">
                <h2 className="text-xl font-bold">{inspection.title}</h2>
              </Link>
              <div className={`flex items-center justify-between p-2 ${statusColors[inspection.status]} text-white`}>
                <div className="text-lg font-bold">{inspection.status}</div>
              </div>
              <div className="mt-2">
                <p><strong>Inspector:</strong> {inspection.inspector}</p>
                <p><strong>Date:</strong> {inspection.date}</p>
                <p><strong>Site:</strong> {inspection.site}</p>
                {inspection.description && <p><strong>Description:</strong> {inspection.description}</p>}
              </div>
            </li>
          ))}
        </ul> */}
        <h1 className="text-2xl font-bold mb-4">Inspections</h1>
        <button
          // onClick={() => setShowNewInspectionForm(true)}
          onClick={()=>router.push('/add-new-inspection')}
          className="bg-blue-500 text-white px-4 py-2 rounded mb-4 flex items-center"
        >
          <FaPlus className="mr-2" /> Add New Inspection
        </button>
        {inspections.length === 0 ? (
          <p className="text-gray-500">No inspections available.</p>
        ) : (
          <ul className="space-y-4">
            {inspections.map((inspection) => (
              <li key={inspection.id} className="bg-white p-4 rounded shadow">
                <Link href={`/inspection-detail?id=${inspection.id}`} className="text-blue-500 hover:underline">
                  <h2 className="text-xl font-bold">
                  {inspection.inspectionType.type}{inspection?.inspectionSite?.siteName?" at "+inspection?.inspectionSite?.siteName:""}
                    {/* {inspection?.inspectionType?.type} / {"IN-"+formatNumber(inspection.unique_id, inspection.user_id)} */}
                    </h2>
                </Link>
                <div className={`flex items-center justify-between p-2 ${getStatusColor(inspection.status)} text-white`}>
                  <div className="text-lg font-bold">{inspection.status}</div>
                </div>
                <div className="mt-2">
                  <p><strong>Inspector:</strong> {inspection?.inspector?.firstName ? inspection.inspector.firstName + " "+ inspection?.inspector?.lastName: inspection?.inspector?.emailId}</p>
                  <p><strong>Date:</strong> {inspection.date}</p>
                  <p><strong>Site:</strong> {inspection?.inspectionSite?.siteName}</p>
                  {inspection.description && <p><strong>Description:</strong> {inspection.description}</p>}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Right Half: Upload Options */}
      <div className="w-full md:w-1/2 p-4 bg-gray-100">
        <h1 className="text-2xl font-bold mb-4">Upload Options</h1>
        <div className="bg-white p-4 rounded shadow mb-4">
          <h2 className="text-xl font-bold mb-2 flex items-center">
            <FaUpload className="mr-2" /> + Upload
          </h2>
          <ul className="space-y-2">
            {['Material', 'Component', 'Form', 'Document', 'Geotag Photo'].map((item, index) => (
              <li key={index} className="bg-gray-50 p-2 rounded flex items-center">
                
                  {item === 'Material' && <Link href="/list/material" className="text-blue-500 hover:underline flex items-center"><FaFile className="mr-2" />{item}</Link>}
                  {item === 'Component' && <Link href="/list/component" className="text-blue-500 hover:underline flex items-center"><FaWrench className="mr-2" />{item}</Link>}
                  {item === 'Form' && <Link href="/list/steel" className="text-blue-500 hover:underline flex items-center"><FaFileAlt className="mr-2" />{item}</Link>}
                  {item === 'Document' && <Link href="/documents-list/upload" className="text-blue-500 hover:underline flex items-center"><FaFile className="mr-2" />{item}</Link>}
                  {item === 'Geotag Photo' && <Link href="/photo" className="text-blue-500 hover:underline flex items-center"><FaImage className="mr-2" />{item}</Link>}
                  
                
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InspecteeDashboard;